require('./smpl-chat-template.html');
require('./styles.less');

var module = angular.module('bbl.module.view-screenshare');

module.directive('simpleChat', ['simpleChat', function(simpleChat) {
  return {
    templateUrl: 'smpl-chat-template.html',
    restrict: 'EA',
    scope: {
      'user': '=',
      'room': '=',
      'visible': '=',
    },

    link: function($scope, $el, $atts) {
      var room = $scope.room,
        user = $scope.user;

      var chat = simpleChat(user, room);

      var replies$ = $el.find('.smpl-replies')[0];

      chat.sub(chat.types.ONREPLY, function(_, msg) {
        $scope.replies = msg;

        setTimeout(function() {
          $scope.$apply();
          replies$.scrollTop = replies$.scrollHeight;
        });
      });

      chat.sub(chat.types.CONNECTED, function() {
        $scope.connected = true;
        setTimeout(function() { $scope.$apply(); });
      });

      $scope.reply = function(msg) {
        chat.send(msg);
      };

      $scope.fromSelf = function(reply) {
        return reply.author === user.username;
      };

      $scope.fm = function(timestamp) {
        return moment(timestamp).format('MMMM Do YYYY, h:mm:ss a');
      };
    }
  };
}]);

module.directive('simpleChatNotif', ['simpleChat', function(simpleChat) {
  return {
    restrict: 'A',
    scope: {
      'user': '=',
      'room': '=',
      'showNotif': '=simpleChatNotif',
    },

    link: function($scope, $el, $atts) {
      var room = $scope.room,
        user = $scope.user;

      var chat = simpleChat(user, room);

      var all = 0, read = 0, unread = 0;
      chat.sub(chat.types.ONREPLY, update);
      $scope.$watch('showNotif', function() { update(); });

      function update(_, msg) {
        var len = msg ? msg.length : all;

        unread = $scope.showNotif ? len - read : len - (read = len);

        $el.attr('data-unread', unread);
        all = len;
      }
    },
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/view-screenshare/chat/index.js
 ** module id = 396
 ** module chunks = 0
 **/